import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// ── 시각 표시 표준 (2026-08-04 KST 고정 → 2026-10-06 사용자 소속 교회 시간대, 다국가 D2) ──
// 계약: API 가 반환하는 datetime 은 UTC(naive-UTC 또는 'Z' 접미). 여기서 표시 시간대로 변환한다.
// 표시 시간대 = 로그인 사용자의 소속 교회 시간대(/api/spa/user 의 timeZone). 한국 회원은 기존과 같이 KST.
// 함수 이름은 호출부 호환을 위해 kst* 그대로 둔다.

let displayTimeZone = 'Asia/Seoul';

/** 인증 스토어가 사용자 정보를 받은 뒤 호출한다. 잘못된 값이면 무시. */
export function setDisplayTimeZone(tz) {
    if (!tz || typeof tz !== 'string') return;
    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        displayTimeZone = tz;
    } catch { /* 알 수 없는 시간대 — 기존 값 유지 */ }
}

export function getDisplayTimeZone() {
    return displayTimeZone;
}

export function kstDateTime(value, withSeconds = false) {
    if (!value) return '-';
    const f = withSeconds ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm';
    return dayjs.utc(value).tz(displayTimeZone).format(f);
}

export function kstDate(value) {
    if (!value) return '-';
    return dayjs.utc(value).tz(displayTimeZone).format('YYYY-MM-DD');
}

// 시각만 표시 — 값은 UTC datetime, KST 시:분(:초)로.
export function kstTime(value, withSeconds = false) {
    if (!value) return '-';
    return dayjs.utc(value).tz(displayTimeZone).format(withSeconds ? 'HH:mm:ss' : 'HH:mm');
}

// date-only(생년월일/기간 등 시각 없는 값): tz 변환 없이 날짜만.
// ISO 문자열이면 앞 10자리(YYYY-MM-DD)를 그대로 사용 → 'Z' 가 붙어도 날짜가 tz 로 밀리지 않음.
export function plainDate(value) {
    if (!value) return '-';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
    return dayjs(value).format('YYYY-MM-DD');
}
